import { initSearchInput } from "@opportunus-lib-js/store/store-search-input";

initSearchInput();
